import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import ReactSVG from "react-svg";
import { Grid } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import {
  Title,
  Text,
  Margin,
  Input,
  Button,
  Select,
  Checkbox,
  Message,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import * as S from "./styles";
import { schema } from "./validation";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import {
  dateMask,
  formatDate,
  // phoneMask,
  checkHasNumber,
  checkHasString,
  checkHasSpecialCharacter,
} from "~/utils/tools";
import { ufSelect, genderSelect } from "~/utils/variables";

import errorSVG from "~/assets/img/icon/error.svg";
import successSVG from "~/assets/img/icon/checkBlack.svg";

import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function FormSignUp() {
  const location = useLocation();
  const mobile = isMobile();
  const [captchaTrue, setCaptcha] = useState(false);
  const [midiaParams, setMidiaParams] = useState({});
  const dispatch = useDispatch();
  const sending = useSelector((state) => state.signUp.sign.sending);
  const errorMessage = useSelector((state) => state.signUp.sign.errorMessage);
  const initialValues = {
    Email: "",
    ConfirmaEmail: "",
    Senha: "",
    ConfirmaSenha: "",
    Estado: ufSelect[0],
    DataNascimento: "",
    TelCelular: "",
    AceitaReceberNoticias: 0,
    AceitaProcessamento: 0,
    Sexo: genderSelect[0],
    Nome: "",
    AceitaTermosLegais: 0,
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paramObj = {};
    for (const [key, value] of queryParams.entries()) {
      paramObj[key] = value;
    }
    setMidiaParams(JSON.stringify(paramObj));
  }, [location]);

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  useEffect(() => {
    dispatch(SignUpActions.setSignUpData());
  }, [dispatch]);

  return (
    <S.FormHolder>
      <Margin mt={6} mb={mobile ? 3 : 4}>
        <Title as="2" levelDesktop="6" level="6" primary emphasis={false}>
          Completa tus datos <br className="mobileOnly" />
          personales
        </Title>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          // enableReinitialize={true}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(SignUpActions.setSignUpData());
            const payloadValues = {
              ...values,
              AceitaProcessamento:
                values.AceitaProcessamento &&
                values.AceitaProcessamento.length > 0
                  ? true
                  : false,
              AceitaReceberNoticias:
                values.AceitaReceberNoticias &&
                values.AceitaReceberNoticias.length > 0
                  ? true
                  : false,
              AceitaTermosLegais:
                values.AceitaTermosLegais &&
                values.AceitaTermosLegais.length > 0
                  ? true
                  : false,
              Estado: values.Estado.value,
              Sexo: values.Sexo.value,
              DataNascimento: formatDate(values.DataNascimento),
              confirm_email: true,
              url: url,
              origin: origin,
              midia: midiaParams,
            };
            delete payloadValues.ConfirmaEmail;
            delete payloadValues.ConfirmaSenha;

            dispatch(SignUpActions.sendSignUpForm(payloadValues));
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <S.GridHolder>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8}>
                    <Input
                      label="Nombre completo"
                      placeholder="Escribe tu nombre"
                      htmlFor="nameFieldFormSignup"
                      name="Nome"
                      value={values.Nome}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={errors.Nome && touched.Nome && errors.Nome}
                      valid={!errors.Nome && touched.Nome && !errors.Nome}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Input
                      mask={dateMask}
                      label="Fecha de nacimiento"
                      placeholder="DD/MM/AAAA"
                      htmlFor="birthFieldFormSignup"
                      name="DataNascimento"
                      value={values.DataNascimento}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={
                        errors.DataNascimento &&
                        touched.DataNascimento &&
                        errors.DataNascimento
                      }
                      valid={
                        !errors.DataNascimento &&
                        touched.DataNascimento &&
                        !errors.DataNascimento
                      }
                      required
                    />
                  </Grid>
                </Grid>
              </S.GridHolder>
              <S.GridHolder>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={8}>
                    <Select
                      label="Género"
                      name="Sexo"
                      placeholder="Selecciona tu género"
                      onChange={setFieldValue}
                        onBlur={handleBlur}
                        value={values.Sexo}
                        errors={errors.Sexo && touched.Sexo && errors.Sexo}
                        valid={!errors.Sexo && touched.Sexo && !errors.Sexo}
                        options={genderSelect}
                        required
                      id="genderFieldFormSignup"
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Select
                      label="Región"
                      name="Estado"
                      placeholder="Selecciona"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={values.Estado}
                      errors={errors.Estado && touched.Estado && errors.Estado}
                      valid={!errors.Estado && touched.Estado && !errors.Estado}
                      options={ufSelect}
                      required
                      id="stateFieldFormSignup"
                    />
                  </Grid>
                </Grid>
              </S.GridHolder>
              <Margin mt={mobile ? 3 : 4} mb={mobile ? 3 : 4}>
                <Title
                  as="2"
                  levelDesktop="6"
                  level="6"
                  primary
                  emphasis={false}
                >
                  Información para crear tu cuenta
                </Title>
              </Margin>
              <Margin mb={mobile ? 4 : 3}>
                <Input
                  label="Correo electrónico"
                  placeholder="¿Qué correo electrónico usas más?"
                  htmlFor="emailFieldFormSignup"
                  name="Email"
                  value={values.Email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={errors.Email && touched.Email && errors.Email}
                  valid={!errors.Email && touched.Email && !errors.Email}
                  required
                />
              </Margin>
              <Margin mb={mobile ? 4 : 3}>
                <Input
                  label="Confirma tu correo electrónico"
                  placeholder="Vuelve a introducir tu correo electrónico"
                  htmlFor="emailConfirmFieldFormSignup"
                  name="ConfirmaEmail"
                  value={values.ConfirmaEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={
                    errors.ConfirmaEmail &&
                    touched.ConfirmaEmail &&
                    errors.ConfirmaEmail
                  }
                  valid={
                    !errors.ConfirmaEmail &&
                    touched.ConfirmaEmail &&
                    !errors.ConfirmaEmail
                  }
                  required
                />
              </Margin>
              <Margin mb={mobile ? 4 : 3}>
                <Input
                  type="password"
                  label="Contraseña"
                  placeholder="Ingresa una contraseña"
                  htmlFor="passwordFieldFormSignup"
                  name="Senha"
                  value={values.Senha}
                  maxLength={12}
                  onChange={handleChange}
                  successIcon={true}
                  showHidePassword={true}
                  hideError={true}
                  validateOnBlur={false}
                  required
                />
              </Margin>
              <Margin mb={mobile ? 8 : 6}>
                <Input
                  type="password"
                  label="Confirma tu contraseña"
                  placeholder="Reescribe tu contraseña"
                  htmlFor="passwordConfirmFieldFormSignup"
                  name="ConfirmaSenha"
                  value={values.ConfirmaSenha}
                  maxLength={12}
                  onChange={handleChange}
                  successIcon={true}
                  showHidePassword={true}
                  hideError={true}
                  validateOnBlur={false}
                  required
                />
              </Margin>

              {errors.Senha || errors.ConfirmaSenha ? (
                <S.PasswordRules>
                  <Text level="1">Tu contraseña debe contener:</Text>
                  <ul>
                    <li
                      className={
                        values.Senha.length === 0 ||
                        values.Senha !== values.ConfirmaSenha
                          ? "error"
                          : ""
                      }
                    >
                      <ReactSVG
                        src={
                          values.Senha.length === 0 ||
                          values.Senha !== values.ConfirmaSenha
                            ? errorSVG
                            : successSVG
                        }
                      />
                      La misma contraseña en los campos de Contraseña y Confirma
                      tu contraseña
                    </li>
                    <li
                      className={
                        values.Senha.length < 8 ||
                        values.ConfirmaSenha.length >= 13
                          ? "error"
                          : ""
                      }
                    >
                      <ReactSVG
                        src={
                          values.Senha.length < 8 || values.Senha.length >= 13
                            ? errorSVG
                            : successSVG
                        }
                      />
                      Mínimo 8 y máximo 12 caracteres
                    </li>
                    <li
                      className={!checkHasString(values.Senha) ? "error" : ""}
                    >
                      <ReactSVG
                        src={
                          !checkHasString(values.Senha) ? errorSVG : successSVG
                        }
                      />
                      Al menos una letra
                    </li>
                    <li
                      className={!checkHasNumber(values.Senha) ? "error" : ""}
                    >
                      <ReactSVG
                        src={
                          !checkHasNumber(values.Senha) ? errorSVG : successSVG
                        }
                      />
                      Al menos un número
                    </li>
                    <li
                      className={
                        !checkHasSpecialCharacter(values.Senha) ? "error" : ""
                      }
                    >
                      <ReactSVG
                        src={
                          !checkHasSpecialCharacter(values.Senha)
                            ? errorSVG
                            : successSVG
                        }
                      />
                      Al menos un caracter especial (Ej: !#@)
                    </li>
                  </ul>
                </S.PasswordRules>
              ) : null}

              <Margin mb={mobile ? 3 : 4}>
                <S.TermsHolder>
                  <Margin mb={1}>
                    <Text level="1" emphasis>
                      Términos de aceptación
                    </Text>
                  </Margin>
                  <Margin mb={2}>
                    <Text level="3">
                      Explicación del uso de datos personales, que pueden ser
                      transferidos a empresas del mismo grupo bajo esquemas
                      vinculantes de acuerdo para la aprobación de dichos datos,
                      así como para terceros que presten servicios a Kenvue.
                    </Text>
                  </Margin>
                  <Margin mb={2}>
                    <label>
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaReceberNoticias"
                        value="1"
                        id="commCheckFormSignup"
                      />
                      <Text level="3">
                        Aceptación de comunicaciones personalizadas
                      </Text>
                    </label>
                  </Margin>
                  <Margin mb={2}>
                    <label>
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaProcessamento"
                        value="1"
                        id="privacyCheckFormSignup"
                      />
                      <Text level="3">
                        <a
                          href="https://www.neutrogena.cl/politica-de-privacidad"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Aceptación Política de privacidad
                        </a>
                      </Text>
                      {errors.AceitaProcessamento &&
                        errors.AceitaProcessamento.length < 50 && (
                          <Message variant="error">
                            {errors.AceitaProcessamento}
                          </Message>
                        )}
                    </label>
                  </Margin>
                  <label>
                    <Field
                      component={Checkbox}
                      type="checkbox"
                      name="AceitaTermosLegais"
                      value="1"
                      id="legalCheckFormSignup"
                    />
                    <Text level="3">
                      <a
                        href="https://www.neutrogena.cl/informacion-legal"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Aceptación Términos legales
                      </a>
                    </Text>
                    {errors.AceitaTermosLegais &&
                      errors.AceitaTermosLegais.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaTermosLegais}
                        </Message>
                      )}
                  </label>
                </S.TermsHolder>
              </Margin>
              <Margin mb={mobile ? 3 : 4}>
                <S.CaptchaHolder>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={setCaptcha}
                  />
                </S.CaptchaHolder>
              </Margin>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Button
                  color={sending ? "disabled" : "primary"}
                  variant="outlined"
                  disabled={sending}
                  onClick={() => history.push("/login")}
                  id="homeButtonFormSignup"
                >
                  Tienes una cuenta? Acceso
                </Button>
                <Margin mb={mobile ? 3 : 0}>
                  <Button
                    className="animation-size"
                    color={
                      !isValid || !dirty || !captchaTrue || sending
                        ? "disabled"
                        : "primary"
                    }
                    type="submit"
                    disabled={!isValid || !dirty || !captchaTrue || sending}
                    id="nextButtonFormSignup"
                  >
                    {sending ? <Loading button /> : "FINALIZAR REGISTRO"}
                  </Button>
                </Margin>
              </S.ButtonsGrid>
              {errorMessage && (
                <Margin mt={mobile ? 3 : 5}>
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                </Margin>
              )}
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
    </S.FormHolder>
  );
}
